import { Input, Select } from 'antd';
import { FilterBar, Button, FormItem, } from 'asumsi-components';
import React from 'react';
import { Link } from 'react-router-dom';

const Search = Input.Search;
export default function (props: any) {
  const { onSearch, onChangeStatus } = props;
  const { Option } = Select;

  const change = (value: string) => {
    onChangeStatus(value);
  }

  return (
    <FilterBar>
      <FormItem>
        <Search onSearch={onSearch} allowClear={false} placeholder="Masukan kata kunci..." />
      </FormItem>
      <FormItem className="pl-8">
        <Select
          style={{ width: "50%" }}
          onChange={change}
          allowClear={false}
          optionFilterProp="children"
          placeholder="Pilih Status">
          <Option key="all" value={""}>All</Option>
          <Option key="active" value={"active"}>Active</Option>
          <Option key="inactive" value={"inactive"}>Inactive</Option>
        </Select>
      </FormItem>
      <FormItem className="asumsi-filter-bar__right">
        <Link to="topics/form">
          <Button className="float-right" type="primary" iconLeft="plus" size="medium" text="Tambah" />
        </Link>
      </FormItem>
    </FilterBar>
  );
}



// WEBPACK FOOTER //
// ./src/pages/topics/libraries/filter.tsx